var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: ["c-hue", _setup.directionClass] }, [
    _c(
      "div",
      {
        ref: "containerRef",
        staticClass: "c-hue-container",
        attrs: {
          role: "slider",
          "aria-valuenow": _vm.colors.hsl.h,
          "aria-valuemin": "0",
          "aria-valuemax": "360",
        },
        on: {
          click: _setup.handleChange,
          mousedown: _setup.handleMouseDown,
          touchmove: _setup.handleChange,
          touchstart: _setup.handleChange,
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "c-hue-pointer",
            style: { top: _setup.pointerTop, left: _setup.pointerLeft },
            attrs: { role: "presentation" },
          },
          [_c("div", { staticClass: "c-hue-picker" })]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }